import { getCurrentInstance, ref } from 'vue';
import { showConfirmValidate } from '@/commons/globalMessage';
import { ModuleBudgetSource, ModuleAccountCombo } from '@/stores/moduleConst';
import baseDetailVoucher from '@/views/base/baseDetailVoucher';

export const useValidateBudgetSourceAccount = () => {
  const { proxy } = getCurrentInstance();
  const passValidate = ref(false);

  /**
   * Cảnh báo khi tài khoản và nguồn không phù hợp
   * @param {*} result 
   * @param {*} isShowInfo 
   * @param {*} ignore 
   * @param {*} isSaveSuccess 
   */
  const onPosted = (result, isShowInfo, ignore, isSaveSuccess) => {
    const detailKeys = Object.keys(proxy._gridDetails);
    let key = detailKeys.find(x => proxy._gridDetails[x] == 'refDetailParallel');
    // show cảnh báo khi ghi sổ
    let isWarningAccount = false;
    var mes = {};
    let budgetSources = proxy.$store.getters[`${ModuleBudgetSource}/items`];

    let accounts = proxy.$store.getters[`${ModuleAccountCombo}/items`];
    let RegularAccount = [];
    let UnRegularAccount = [];
    // Danh sách tk thường xuyên
    proxy.$ms.constant.AccountNumber.RegularAccount.forEach(element => {
      RegularAccount = RegularAccount.concat(accounts.map(x => x.account_number).filter(x => x.startsWith(element)));
    });
    // Danh sách tk khác thường xuyên
    proxy.$ms.constant.AccountNumber.UnRegularAccount.forEach(element => {
      UnRegularAccount = UnRegularAccount.concat(
        accounts.map(x => x.account_number).filter(x => x.startsWith(element))
      );
    });

    // xem tài khoản có phù hợp không nhập bên trên
    proxy.gridDetail.dataView.forEach(item => {
      let itemDetail = budgetSources.find(x => x.budget_source_id == item.budget_source_id);
      if (itemDetail) {
        if (
          itemDetail.group_property_type &&
          itemDetail.group_property_type == proxy.$ms.constant.BudgetSourceGroupPropertyType.Regular
        ) {
          if (RegularAccount.includes(item.debit_account) || RegularAccount.includes(item.credit_account)) {
            isWarningAccount = true;
            return;
          }
        } else {
          if (UnRegularAccount.includes(item.debit_account) || UnRegularAccount.includes(item.credit_account)) {
            isWarningAccount = true;
            return;
          }
        }
      }
    });

    // xem tài khoản có phù hợp không ở hạch toán đồng thời
    proxy.model[key]
      ?.filter(x => x.state != proxy.$ms.constant.ModelState.Empty || x.state != proxy.$ms.constant.ModelState.Delete)
      .forEach(item => {
        let itemDetail = budgetSources.find(x => x.budget_source_id == item.budget_source_id);
        if (itemDetail) {
          if (
            itemDetail.group_property_type &&
            itemDetail.group_property_type == proxy.$ms.constant.BudgetSourceGroupPropertyType.Regular
          ) {
            if (RegularAccount.includes(item.debit_account) || RegularAccount.includes(item.credit_account)) {
              isWarningAccount = true;
              return;
            }
          } else {
            if (UnRegularAccount.includes(item.debit_account) || UnRegularAccount.includes(item.credit_account)) {
              isWarningAccount = true;
              return;
            }
          }
        }
      });
    
    // nếu không phù hợp show cảnh báo
    if (isWarningAccount && !passValidate.value) {
      showConfirmValidate(
        proxy.$tm('i18nBaseForm.BUPlanReceipt.ValidateWarningAccountPostedMessage'),
        proxy.$tm('i18nBaseForm.BUPlanReceipt.ValidateWarningAccountPostedTitle')
      ).then(answer => {
        if (answer) {
          // đồng ý thì là mode sửa
          proxy.editMode = proxy.$ms.constant.FormState.Edit;
        } else {
          passValidate.value = true;
          proxy.super('onPosted', baseDetailVoucher, result, isShowInfo, ignore, isSaveSuccess);
        }
      });
    } else {
      // nếu phù hợp thì ghi sổ bt
      proxy.super('onPosted', baseDetailVoucher, result, isShowInfo, ignore, isSaveSuccess);
    }
  };

  const customUnPostedSuccess=(res, param)=>{
    passValidate.value = false;
    proxy.super('customUnPostedSuccess', baseDetailVoucher, res, param);
  }

  return {
    onPosted,
    customUnPostedSuccess,
    passValidate
  };
};
